export const planTypes = {
  MEDICAL_FILE: 'medical_file',
  ONE_TIME: 'one_time',
  FAMILY: 'family',
  INDIVIDUAL_MEMBERSHIP: 'individual_membership',
  BNPL: 'bnpl',
}
